<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <p class="top_cent_p">
              <i class="el-icon-location"></i>
              <span>天津</span>
              <i class="el-icon-arrow-down icon"></i>
            </p>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{path:'/'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li>登陆 | 注册</li>
            <li>商会后台</li>
            <li>卖家中心</li>
            <li>政府机构</li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="cent">
      <img src="../../assets/img/dingdan/contract_bg.png" alt />
    </div>
    <div class="cent_1">
      <div class="cent_nive">
        <div class="cent_nive_1">
          <div class="cent_img"></div>
          <p>商汇（天津）信息技术有限公司</p>
        </div>
        <div class="content_one2_right1">
          <p>需求标题</p>
          <p>{{service_name}}</p>
        </div>
        <div class="content_one2_right1">
          <p>订单金额</p>
          <p style="color:#F7681E;">￥{{goods_price}}</p>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="content_1">
        <div class="content_top">
          <div :class="{active:1==num}" @click="num=1">
            <img src="../../assets/img/dingdan/tabbar_icon_contract_nor.png" alt v-show="num==2" />
            <img src="../../assets/img/dingdan/tabbar_icon_contract_sel.png" alt v-show="num==1" />
            <p>
              <a href="#">模板合同</a>
            </p>
          </div>
          <div :class="{active:2==num}" @click="num=2">
            <img src="../../assets/img/dingdan/tabbar_icon_contract_nor.png" alt v-show="num==1" />
            <img src="../../assets/img/dingdan/tabbar_icon_contract_sel.png" alt v-show="num==2" />
            <p>
              <a href="#">自定义合同</a>
            </p>
          </div>
        </div>
        <div class="content_moban" v-show="num==1">
          <div class="content_moban_1">
            <p class="content_four_1_1">合同内容</p>
            <div class="content_moban_bot">
              <div class="content_moban_bot_1">
                <p class="shuom">合同说明:</p>
                <p>雇主与服务商应当充分沟通、并在合同中明确服务项目的具体内容，如项目描述、产品功能描述、服务要求等。本合同为线上合同，以此作为平</p>
              </div>
              <div class="content_moban_bot_2">
                <p>
                  <span style="color:#FF4D43">*</span> 服务内容:
                </p>
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入内容"
                  class="input"
                  v-model="form.service_content"
                ></el-input>
              </div>
              <div class="content_moban_bot_3">
                <p>
                  <span style="color:#FF4D43">*</span> 服务工期:
                </p>
                <div class="picker">
                  <el-date-picker
                    class="riqi"
                    v-model="form.start_time"
                    type="date"
                    placeholder="选择项目开始时间"
                  ></el-date-picker>
                  <p style="width:20px;text-align:center">至</p>
                  <el-date-picker
                    class="riqi"
                    v-model="form.end_time"
                    type="date"
                    placeholder="选择项目结束时间"
                  ></el-date-picker>
                </div>
              </div>
              <div class="content_moban_bot_3">
                <p>
                  <span style="color:#FF4D43">*</span> &nbsp;服务费：
                </p>
                <el-input
                  placeholder="请输入内容"
                  style="float:left"
                  v-model="form.goods_price"
                  class="input1"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="content_moban_2">
            <p class="content_four_1_1">项目阶段</p>
            <div v-for="(item,index) in lists1" :key="index" class="content_moban_top">
              <div class="content_moban_top_1">
                <p class="content_moban_p">
                  <span style="color:#FF4D43">*</span> 阶段名称:
                </p>
                <el-input placeholder="第一阶段原型设计" v-model="lists1[index][0].content" class="int"></el-input>
              </div>
              <div class="content_moban_top_2">
                <p class="content_moban_p">
                  <span style="color:#FF4D43">*</span> 服务内容:
                </p>
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="lists1[index][1].content"
                  class="int"
                ></el-input>
              </div>
              <div class="content_moban_top_1">
                <p class="content_moban_p">
                  <span style="color:#FF4D43">*</span> 服务工期:
                </p>
                <div class="picker">
                  <el-date-picker
                    class="riqi2"
                    v-model="lists1[index][2].begin"
                    type="date"
                    placeholder="选择项目开始时间"
                  ></el-date-picker>
                  <p
                    style="width:20px;text-align:center;font-size: 14px;color: #666;float: left;line-height: 35px;margin-right:20px;"
                  >至</p>
                  <el-date-picker
                    class="riqi2"
                    v-model="lists1[index][2].end"
                    type="date"
                    placeholder="选择项目结束时间"
                  ></el-date-picker>
                </div>
              </div>
              <div class="content_moban_top_1">
                <p class="content_moban_p">
                  <span style="color:#FF4D43">*</span> 付款金额:
                </p>
                <el-input
                  placeholder="请输入内容"
                  v-model="lists1[index][3].content"
                  style="float:left"
                  class="input2"
                ></el-input>
              </div>
              <div class="content_moban_bottom_1" @click="addlistdel(index)">
                <img src="../../assets/img/dingdan/contract_btn_del_hover.png" alt />
              </div>
            </div>
            <div class="content_moban_bottom" @click="addlist()">
              <img src="../../assets/img/dingdan/contract_btn_add_nor.png" alt />
            </div>
          </div>
          <div class="content_moban_2">
            <p class="content_four_1_1">责任&义务</p>
            <div class="zerren">
              <div class="zerren1">
                <div class="zerren_1">
                  <p style="float:left;color:#FF4D43">*</p>
                  <p style="float:right">雇主</p>
                  <p style="float:right;font-size:14px">权利义务责任:</p>
                </div>
                <el-input
                  type="textarea"
                  :rows="4"
                  v-model="form1.member_accountability"
                  placeholder="请输入内容"
                  class="zerren_input"
                ></el-input>
              </div>
              <div class="zerren1">
                <div class="zerren_1">
                  <p style="float:left;color:#FF4D43">*</p>
                  <p style="float:right">服务商</p>
                  <p style="float:right;font-size:14px">权利义务责任:</p>
                </div>
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入内容"
                  v-model="form1.provider_accountability"
                  class="zerren_input"
                ></el-input>
              </div>
              <div class="zerren1">
                <p class="content_moban_p">
                  <span style="color:#FF4D43">*</span> 验收标准:
                </p>
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入内容"
                  v-model="form1.acceptance_criteria"
                  class="zerren_input"
                ></el-input>
              </div>
              <div class="zerren1">
                <p class="content_moban_p">
                  <span style="color:#FF4D43">*</span> 违约责任:
                </p>
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入内容"
                  v-model="form1.default_accountability"
                  class="zerren_input"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="content_moban_3">
            <div class="content_moban_thee">
              <p>《通用合同》</p>
            </div>
            <div class="content_moban_three">
              <div class="content_moban_three_1">
                <p
                  style="text-align:center;line-height:30px;font-size:24px;padding:10px 0;"
                >商业服务交易协议</p>
                <p
                  style="text-indent:25px;line-height:25px;"
                >本协议由甲方和乙方(商企服服务商）在线签订，请甲方仔细阅读协议内容，勾选接受本协议，即意味着已阅读、理解并接受本协议所有条款，并对本协议各条款及相应的法律后果已全部知晓并充分认可。甲方勾选本协议后，即可产生法律约束力。</p>
                <p>一、定义</p>
                <p style="text-indent:25px;">1、商企服平台：指基于商会的综合性企业服务平台，企业服务(商业服务线上交易)是商企服平台中一个重要功能模块。</p>
                <p style="text-indent:25px;">2、用户：指在商企服平台合法注册，接受相关协议、规则、制度等的会员。</p>
                <p style="text-indent:25px;">3、甲方：指在商企服平台上发布服务需求、购买并支付服务的用户。</p>
                <p style="text-indent:25px;">4、乙方：指在商企服平台提供商业服务的用户，即服务商。</p>
                <p style="text-indent:25px;">5、服务需求：指甲方基于自身需求向乙方提出的具体服务要求。</p>
                <p style="text-indent:25px;">6、服务费：指甲方和乙方的交易金额，即本协议约定的交易金额及后续经协商调整后确定的交易总金额。</p>
                <p style="text-indent:25px;">7、平台账户：指用户在商企服平台上注册的账号，用户只能通过该账号登录商企服平台进行交易。</p>
                <p>二、甲方的权利与义务</p>
                <p
                  style="text-indent:25px;"
                >1、甲方应根据服务需求主动向乙方提交该项目所需的相关资料，并保证资料真实、合法、有效，如因甲方未按照前述标准提供资料导致乙方无法履行协议义务的，由此产生的责任由甲方自行承担。</p>
                <p
                  style="text-indent:25px;"
                >2、甲方有权对服务需求对乙方的服务提出建议和思路，同时有权在验收时对乙方的服务成果提出修改意见，但甲方提出的建议或思路及修改意见应当明确具体，如含糊不清，乙方有权不听取甲方建议或拒绝修改，甲方不得借机拖延进度及应支付的款项，甲方提出超出协议约定范围的修改要求，乙方有权拒绝或另行收费。</p>
                <p style="text-indent:25px;">3、甲方应充分了解且同意遵守商企服平台公布的所有协议、规则、制度等，并按照相关规定处理相关交易事项。</p>
                <p
                  style="text-indent:25px;"
                >4、甲方应及时验收乙方交付的服务成果，包括阶段成果和最终成果，如乙方向甲方提交服务成果后7日内甲方未给出具体验收意见的，视为乙方提交的服务成果合格。如有下一阶段服务的，乙方有权继续推进。如下一阶段服务因甲方愿意导致无法继续推进的，乙方不承担任何责任。</p>
                <p style="text-indent:25px;">5、甲方有义务向乙方提供必要的配合义务，包括提供必要的资料、及时验收、及时回复等。</p>
                <p
                  style="text-indent:25px;"
                >6、甲方应保证委托的服务需求不违反任何法律法规或侵犯他人合法权益，否则乙方有权拒绝提供服务并有权立即解除本协议，甲方已支付服务费作为违约金不予退还。</p>
                <p
                  style="text-indent:25px;"
                >7、甲方应保证合法使用乙方提交的服务成果，不得将服务成果用于任何违法违规或侵犯他人合法权益的活动，如甲方违反，应承担全部责任。</p>
                <p
                  style="text-indent:25px;"
                >8、甲方同意本协议仅作为维护交易内容和双方权利义务的基本约定，具体的服务项目、期限、金额等甲方在商企服平台下单时应与乙方进行约定并/或签订相关合同。</p>
                <p
                  style="text-indent:25px;"
                >9、甲方下单时，应仔细确认所需服务内容、价格、数量等信息，下单后即表示甲方对下单信息的认可，支付成功后订单即生效。</p>
                <p
                  style="text-indent:25px;"
                >10、如乙方未在本协议约定期限内完成工作的，甲方有权拒绝支付全部或部分服务费，甲方对已支付的服务费可申请退款，申请退款48小时内，乙方仍不能提交服务成果的，乙方应同意退款。</p>
                <p>三、乙方的权利与义务</p>
                <p style="text-indent:25px;">1、乙方应按照本协议的约定向甲方提供服务。</p>
                <p
                  style="text-indent:25px;"
                >2、乙方应当积极听取甲方的修改意见，对甲方提出的合理需求及明确的修改意见，乙方应在提供服务成果后提供不超过3次的修改服务，但超出协议约定内容的修改需求乙方有权拒绝。</p>
                <p style="text-indent:25px;">3、乙方应该对甲方提供的相关资料承担保密义务，不得向第三方透露。</p>
                <p style="text-indent:25px;">4、乙方有权要求甲方按照协议约定支付相应服务费，如甲方未按照约定支付的，乙方有权利拒绝或顺延提供服务。</p>
                <p
                  style="text-indent:25px;"
                >5、双方约定分阶段工作的，乙方完成阶段性工作，甲方应在7日内予以验收，验收合格后应及时支付该阶段服务费，如未按约定验收，视为验收合格，乙方有权要求甲方支付已完成阶段服务费。</p>
                <p style="text-indent:25px;">6、乙方应按照法律规定自行缴纳相应税费。</p>
                <p>四、服务费流转和发票</p>
                <p style="text-indent:25px;">1、乙方同意委托商汇（天津）信息技术有限公司代为处理服务费事宜。</p>
                <p style="text-indent:25px;">2、乙方应按照甲方最终实际支付服务费为甲方开具合法有效的发票。</p>
                <p>五、知识产权</p>
                <p
                  style="text-indent:25px;"
                >1、本协议所产生的服务成果的知识产权在甲方支付完全部服务费后，归甲方所有。乙方禁止转让该知识产权，但可将服务成果用于案例展示或参加评选。双方另有约定的除外。</p>
                <p style="text-indent:25px;">2、乙方应保证服务成果不存在侵犯第三方的所有权、知识产权、名誉权、肖像权等，并承担因此产生的全部责任。</p>
                <p
                  style="text-indent:25px;"
                >3、甲方的服务需求如需采购第三方知识产权产品的，乙方应及时告知甲方，取得甲方书面同意且支付采购费用后，乙方予以采购并使用，或由甲方自行采购后提供给乙方使用。</p>
                <p
                  style="text-indent:25px;"
                >4、甲方在未付清所有服务费之前，不得使用服务成果，不得主张知识产权。如甲方违反，导致乙方或其他方损失的，甲方应承担因此产生的全部责任。</p>
                <p>六、责任限制</p>
                <p style="text-indent:25px;">乙方依照法律法规履行义务，但对于下述原因导致的合同履行障碍、延后、变更等情况，乙方不承担违约责任：</p>
                <p style="text-indent:25px;">1、因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；</p>
                <p style="text-indent:25px;">2、因电力供应故障、通讯网络故障等公共服务因素或第三人因素；</p>
                <p style="text-indent:25px;">3、在乙方已尽力管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。</p>
                <p>七、违约责任</p>
                <p
                  style="text-indent:25px;"
                >1、乙方未按本协议约定提交服务成果的，应按照服务项目费用总额的1%/天向甲方支付违约金（可在未付款中扣除），延期达15天及以上的，除双方另有约定外，双方均有权解除协议，乙方已收取的服务费应予退还，同时乙方承担违约金。乙方承担责任以收取的服务费为限，仅在已收取的服务费范围内承担责任。</p>
                <p style="text-indent:25px;">2、甲方在服务期间无正当理由单方终止协议的，已支付服务费无权要求返还。</p>
                <p style="text-indent:25px;">3、乙方在服务期间无正当理由单方终止协议的，所收取服务费应当全部返还甲方。</p>
                <p>八、适用法律与争议解决</p>
                <p style="text-indent:25px;">1、本协议及与本协议有关的争议、解释等，均适用中华人民共和国法律。</p>
                <p style="text-indent:25px;">2、本协议履行过程中，如有争议，双方应当友好协商解决；协商不成，双方一致同意提交当地冲裁委员会进行仲裁。</p>
                <p>九、其他</p>
                <p style="text-indent:25px;">1、本协议以电子文本形式生成，双方勾选本协议后，即表示同意本协议，与手签协议具同等法律效力。</p>
                <p style="text-indent:25px;">2、本协议中的任何约定如违反法律法规而无效的，该条款不影响本协议其他条款的效力。</p>
                <p>十、 本协议由商汇（天津）信息技术有限公司解释，自发布之日起实行。</p>
              </div>
            </div>
          </div>
          <div class="bottom" @click="jump()">
            <a href="#">生成合同</a>
          </div>
        </div>
        <div class="content_zdy" v-show="num==2">
          <div class="content_zdy_1">
            <p class="content_four_1_1">合同内容</p>
            <div class="content_moban_bot" style="margin-bottom:40px;">
              <div class="content_moban_bot_1" style="height:80px;">
                <p class="shuom">合同说明:</p>
                <p>雇主与服务商应当充分沟通、并在合同中明确服务项目的具体内容，如项目描述、产品功能描述、服务要求等。本合同为线上合同，以此作为平</p>
              </div>
            </div>
            <div class="content_zdy_2">
              <div class="content_moban_bot_1" style="height:80px">
                <p class="shuom">上传合同:</p>
                <p style="color:#FFAB1D;">请上传清晰并且您已签署的合同，提交后合同将会发送给对方，由对方下载并签署后重新上传，重新上传的合同将作为最终版合同。</p>
              </div>
              <div class="content_zdy_bottom">
                <el-form :model="article" label-width="120px">
                  <el-form-item label style="width: 700px;" prop="image">
                    <template>
                      <el-upload
                        :action="upImgUrl"
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove"
                        :on-success="handleAvatarSuccess"
                        :limit="10"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                      <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="article.image" alt />
                      </el-dialog>
                    </template>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
          <div class="content_moban_3">
            <div class="content_moban_thee">
              <p>《通用合同》</p>
            </div>
            <div class="content_moban_three">
              <div class="content_moban_three_1">
                <p
                  style="text-align:center;line-height:30px;font-size:24px;padding:10px 0;"
                >商业服务交易协议</p>
                <p
                  style="text-indent:25px;line-height:25px;"
                >本协议由甲方和乙方(商企服服务商）在线签订，请甲方仔细阅读协议内容，勾选接受本协议，即意味着已阅读、理解并接受本协议所有条款，并对本协议各条款及相应的法律后果已全部知晓并充分认可。甲方勾选本协议后，即可产生法律约束力。</p>
                <p>一、定义</p>
                <p style="text-indent:25px;">1、商企服平台：指基于商会的综合性企业服务平台，企业服务(商业服务线上交易)是商企服平台中一个重要功能模块。</p>
                <p style="text-indent:25px;">2、用户：指在商企服平台合法注册，接受相关协议、规则、制度等的会员。</p>
                <p style="text-indent:25px;">3、甲方：指在商企服平台上发布服务需求、购买并支付服务的用户。</p>
                <p style="text-indent:25px;">4、乙方：指在商企服平台提供商业服务的用户，即服务商。</p>
                <p style="text-indent:25px;">5、服务需求：指甲方基于自身需求向乙方提出的具体服务要求。</p>
                <p style="text-indent:25px;">6、服务费：指甲方和乙方的交易金额，即本协议约定的交易金额及后续经协商调整后确定的交易总金额。</p>
                <p style="text-indent:25px;">7、平台账户：指用户在商企服平台上注册的账号，用户只能通过该账号登录商企服平台进行交易。</p>
                <p>二、甲方的权利与义务</p>
                <p
                  style="text-indent:25px;"
                >1、甲方应根据服务需求主动向乙方提交该项目所需的相关资料，并保证资料真实、合法、有效，如因甲方未按照前述标准提供资料导致乙方无法履行协议义务的，由此产生的责任由甲方自行承担。</p>
                <p
                  style="text-indent:25px;"
                >2、甲方有权对服务需求对乙方的服务提出建议和思路，同时有权在验收时对乙方的服务成果提出修改意见，但甲方提出的建议或思路及修改意见应当明确具体，如含糊不清，乙方有权不听取甲方建议或拒绝修改，甲方不得借机拖延进度及应支付的款项，甲方提出超出协议约定范围的修改要求，乙方有权拒绝或另行收费。</p>
                <p style="text-indent:25px;">3、甲方应充分了解且同意遵守商企服平台公布的所有协议、规则、制度等，并按照相关规定处理相关交易事项。</p>
                <p
                  style="text-indent:25px;"
                >4、甲方应及时验收乙方交付的服务成果，包括阶段成果和最终成果，如乙方向甲方提交服务成果后7日内甲方未给出具体验收意见的，视为乙方提交的服务成果合格。如有下一阶段服务的，乙方有权继续推进。如下一阶段服务因甲方愿意导致无法继续推进的，乙方不承担任何责任。</p>
                <p style="text-indent:25px;">5、甲方有义务向乙方提供必要的配合义务，包括提供必要的资料、及时验收、及时回复等。</p>
                <p
                  style="text-indent:25px;"
                >6、甲方应保证委托的服务需求不违反任何法律法规或侵犯他人合法权益，否则乙方有权拒绝提供服务并有权立即解除本协议，甲方已支付服务费作为违约金不予退还。</p>
                <p
                  style="text-indent:25px;"
                >7、甲方应保证合法使用乙方提交的服务成果，不得将服务成果用于任何违法违规或侵犯他人合法权益的活动，如甲方违反，应承担全部责任。</p>
                <p
                  style="text-indent:25px;"
                >8、甲方同意本协议仅作为维护交易内容和双方权利义务的基本约定，具体的服务项目、期限、金额等甲方在商企服平台下单时应与乙方进行约定并/或签订相关合同。</p>
                <p
                  style="text-indent:25px;"
                >9、甲方下单时，应仔细确认所需服务内容、价格、数量等信息，下单后即表示甲方对下单信息的认可，支付成功后订单即生效。</p>
                <p
                  style="text-indent:25px;"
                >10、如乙方未在本协议约定期限内完成工作的，甲方有权拒绝支付全部或部分服务费，甲方对已支付的服务费可申请退款，申请退款48小时内，乙方仍不能提交服务成果的，乙方应同意退款。</p>
                <p>三、乙方的权利与义务</p>
                <p style="text-indent:25px;">1、乙方应按照本协议的约定向甲方提供服务。</p>
                <p
                  style="text-indent:25px;"
                >2、乙方应当积极听取甲方的修改意见，对甲方提出的合理需求及明确的修改意见，乙方应在提供服务成果后提供不超过3次的修改服务，但超出协议约定内容的修改需求乙方有权拒绝。</p>
                <p style="text-indent:25px;">3、乙方应该对甲方提供的相关资料承担保密义务，不得向第三方透露。</p>
                <p style="text-indent:25px;">4、乙方有权要求甲方按照协议约定支付相应服务费，如甲方未按照约定支付的，乙方有权利拒绝或顺延提供服务。</p>
                <p
                  style="text-indent:25px;"
                >5、双方约定分阶段工作的，乙方完成阶段性工作，甲方应在7日内予以验收，验收合格后应及时支付该阶段服务费，如未按约定验收，视为验收合格，乙方有权要求甲方支付已完成阶段服务费。</p>
                <p style="text-indent:25px;">6、乙方应按照法律规定自行缴纳相应税费。</p>
                <p>四、服务费流转和发票</p>
                <p style="text-indent:25px;">1、乙方同意委托商汇（天津）信息技术有限公司代为处理服务费事宜。</p>
                <p style="text-indent:25px;">2、乙方应按照甲方最终实际支付服务费为甲方开具合法有效的发票。</p>
                <p>五、知识产权</p>
                <p
                  style="text-indent:25px;"
                >1、本协议所产生的服务成果的知识产权在甲方支付完全部服务费后，归甲方所有。乙方禁止转让该知识产权，但可将服务成果用于案例展示或参加评选。双方另有约定的除外。</p>
                <p style="text-indent:25px;">2、乙方应保证服务成果不存在侵犯第三方的所有权、知识产权、名誉权、肖像权等，并承担因此产生的全部责任。</p>
                <p
                  style="text-indent:25px;"
                >3、甲方的服务需求如需采购第三方知识产权产品的，乙方应及时告知甲方，取得甲方书面同意且支付采购费用后，乙方予以采购并使用，或由甲方自行采购后提供给乙方使用。</p>
                <p
                  style="text-indent:25px;"
                >4、甲方在未付清所有服务费之前，不得使用服务成果，不得主张知识产权。如甲方违反，导致乙方或其他方损失的，甲方应承担因此产生的全部责任。</p>
                <p>六、责任限制</p>
                <p style="text-indent:25px;">乙方依照法律法规履行义务，但对于下述原因导致的合同履行障碍、延后、变更等情况，乙方不承担违约责任：</p>
                <p style="text-indent:25px;">1、因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；</p>
                <p style="text-indent:25px;">2、因电力供应故障、通讯网络故障等公共服务因素或第三人因素；</p>
                <p style="text-indent:25px;">3、在乙方已尽力管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。</p>
                <p>七、违约责任</p>
                <p
                  style="text-indent:25px;"
                >1、乙方未按本协议约定提交服务成果的，应按照服务项目费用总额的1%/天向甲方支付违约金（可在未付款中扣除），延期达15天及以上的，除双方另有约定外，双方均有权解除协议，乙方已收取的服务费应予退还，同时乙方承担违约金。乙方承担责任以收取的服务费为限，仅在已收取的服务费范围内承担责任。</p>
                <p style="text-indent:25px;">2、甲方在服务期间无正当理由单方终止协议的，已支付服务费无权要求返还。</p>
                <p style="text-indent:25px;">3、乙方在服务期间无正当理由单方终止协议的，所收取服务费应当全部返还甲方。</p>
                <p>八、适用法律与争议解决</p>
                <p style="text-indent:25px;">1、本协议及与本协议有关的争议、解释等，均适用中华人民共和国法律。</p>
                <p style="text-indent:25px;">2、本协议履行过程中，如有争议，双方应当友好协商解决；协商不成，双方一致同意提交当地冲裁委员会进行仲裁。</p>
                <p>九、其他</p>
                <p style="text-indent:25px;">1、本协议以电子文本形式生成，双方勾选本协议后，即表示同意本协议，与手签协议具同等法律效力。</p>
                <p style="text-indent:25px;">2、本协议中的任何约定如违反法律法规而无效的，该条款不影响本协议其他条款的效力。</p>
                <p>十、 本协议由商汇（天津）信息技术有限公司解释，自发布之日起实行。</p>
              </div>
            </div>
          </div>
          <div class="bottom" @click="jump2()">
            <a href="#">发起合同</a>
          </div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li @click="floor()">
            <a href="#">关于商企服</a>
          </li>
          <li @click="leimu()">
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible1" width="840px">
      <div class="dialoa_top">
        <p>签署合同</p>
      </div>
      <div class="dialoa_left">
        <div class="dialoa_left_1">
          <el-radio v-model="radio" label="1" style="margin-right:20px;">在线签署</el-radio>
          <el-radio v-model="radio" label="2">上传已盖章合同签署</el-radio>
          <p class="download" v-show="radio == '2'">（下载合同-盖章-上传合同）</p>
        </div>
        <div class="dialoa_left_one" v-show="radio == '1'">
          <p>使用微信扫描二维码，手绘个人签名</p>
          <img src="../../assets/img/hover_btn_xcx.png" alt class="dialoa_left_one_img" />
        </div>
        <div class="dialoa_left_two" v-show="radio == '2'">
          <p>
            还没有下载合同？
            <a href="#" @click="xiazai()">点击下载</a>
          </p>
          <div class="dialoa_left_two_1">
            <el-form :model="article">
              <el-form-item prop="image">
                <template>
                  <el-upload
                    :action="upImgUrl"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :on-success="handleAvatarSuccess"
                    :limit="10"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible2">
                    <img width="100%" :src="article.image" alt />
                  </el-dialog>
                </template>
              </el-form-item>
            </el-form>
          </div>
          <el-button type="primary" class="submission" @click="jumpp()">提交</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible3" width="560px">
      <div class="dialog1_cont">
        <img src="../../assets/img/dingdan/contract_icon_ht01.png" alt />
      </div>
      <p class="dialog1_cont_p">是否确定签署合同？</p>
      <p class="dialog1_cont_p1">双方均同意签署后，合同开始生效！此合同将作为线上交易过程的执行标准，以及维护双方利益的依据！若对合同内容有疑问，请及时联系对方</p>
      <div class="dialog1_bootm">
        <el-button type="primary" plain class="botton_botm">取消</el-button>
        <el-button type="primary" plain class="botton_botm" @click="jump1()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible4" width="560px">
      <div class="dialog1_cont">
        <img src="../../assets/img/dingdan/contract_icon_ht01.png" alt />
      </div>
      <p class="dialog1_cont_p">合同发送成功！</p>
      <p class="dialog1_cont_p1">请耐心等待服务商签署</p>
      <div class="dialog1_bootm1">
        <el-button type="primary" class="button_fan" @click="next()">返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { createContract, uploadContractImg, createPdf } from "@/http/api";
import VueNeditorWrap from "vue-neditor-wrap";
import editor from "@/config/editor";
import config from "@/config/index";
export default {
  components: {
    VueNeditorWrap
  },
  data() {
    return {
      radio: "1",
      value1: "",
      num: 1,
      dialogVisible: false,
      dialogVisible1: false,
      dialogImageUrl: "",
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      form: {
        //合同内容
        service_content: "",
        start_time: "",
        end_time: "",
        goods_price: ""
      },
      form1: {
        //合同内容
        member_accountability: "",
        provider_accountability: "",
        acceptance_criteria: "",
        default_accountability: ""
      },
      lists1: [
        [
          { title: "阶段名称", content: "", name: "name", type: "input" },
          { title: "服务内容", content: "", name: "content", type: "input" },
          {
            title: "服务工期",
            content: "",
            name: "time",
            type: "money",
            begin: "",
            end: ""
          },
          { title: "付款金额", content: "", name: "money", type: "money" }
        ]
      ],
      upImgUrl: config.baseUrl + "/WebProgram/UpFile/uploadContractImg",
      imgPath: config.imgPath,
      article: {
        image: ""
      },
      created: []
    };
  },
  methods: {
    // 跳转
    floor() {
      this.$router.push({ name: "guanyu" });
    },
    leimu() {
      this.$router.push({ name: "home" });
    },
    table(index) {
      this.numm = index;
    },
    //添加
    addlist() {
      const list = [
        { title: "阶段名称", content: "", name: "name", type: "input" },
        { title: "服务内容", content: "", name: "content", type: "input" },
        {
          title: "服务工期",
          content: "",
          name: "time",
          type: "money",
          begin: "",
          end: ""
        },
        { title: "付款金额", content: "", name: "money", type: "money" }
      ];
      this.lists1.push(list);
    },
    //删除
    addlistdel(index) {
      if (index != 0) {
        this.lists1.splice(index, 1);
      }
    },
    jumpp() {
      this.dialogVisible1 = false;
      this.dialogVisible3 = true;
    },
    jump1() {
      this.dialogVisible3 = false;
      this.dialogVisible4 = true;
    },
    jump(num,form) {
      var id = this.$route.query.goods_id;
      this.token = localStorage.getItem("token");
      console.log(this.lists1.content)
      if (
        this.form.service_content &&
        this.form1.member_accountability &&
        this.form1.provider_accountability &&
        this.form1.acceptance_criteria &&
        this.form1.default_accountability &&
        this.form.start_time &&
        this.form.end_time &&
        this.lists1 &&
        this.form.goods_price != ""
      ) {
        this.dialogVisible1 = true;
        this.dialogVisible3 = false;
        createContract({
          order_id: id,
          token: this.token,
          contract_type: this.num,
          promoter_identity: "",
          contract_promoter: "",
          service_content: this.form.service_content,
          start_time: this.form.start_time,
          end_time: this.form.end_time,
          goods_price: this.form.goods_price,
          member_accountability: this.form1.member_accountability,
          provider_accountability: this.form1.provider_accountability,
          acceptance_criteria: this.form1.acceptance_criteria,
          default_accountability: this.form1.default_accountability,
          project_phase: JSON.stringify(this.lists1)
        }).then(res => {
          if (res.data.errcode === 200) {
            this.created = res.data.data;
            localStorage.setItem("hetong_id", res.data.data);
          }
        });
      } else {
        alert("请填写内容");
      }
    },
    jump2(num) {
      this.dialogVisible3 = true;
      var id = this.$route.query.goods_id;
      this.token = localStorage.getItem("token");
      createContract({
        order_id: id,
        token: this.token,
        contract_type: this.num,
        promoter_identity: "",
        contract_promoter: "",
        service_content: this.form.service_content,
        start_time: this.form.start_time,
        end_time: this.form.end_time,
        goods_price: this.form.goods_price,
        member_accountability: this.form1.member_accountability,
        provider_accountability: this.form1.provider_accountability,
        acceptance_criteria: this.form1.acceptance_criteria,
        default_accountability: this.form1.default_accountability,
        project_phase: JSON.stringify(this.lists1)
      }).then(res => {
        if (res.data.errcode === 200) {
          // this.$router.go(-2);
          localStorage.setItem("hetong_id", res.data.data);
        }
      });
    },
    xiazai(created) {
      this.token = localStorage.getItem("token");
      createPdf({
        token: this.token,
        contract_id: this.created
      });
    },
    next() {
      this.$router.go(-1);
    },
    handleRemove(file, fileList) {
      this.article.image = "";
    },
    handlePictureCardPreview(file) {
      this.dialogVisible = true;
      this.dialogVisible2 = true;
    },
    handleAvatarSuccess(res, file) {
      console.log(file);
      this.article.image = res.data.file_name;
      console.log(res.data);
    }
  },
  created() {
    var id = this.$route.query.goods_id;
    this.goods_price = this.$route.query.goods_price;
    this.service_name = this.$route.query.service_name;
    console.log(id);
    this.$emit("header", true); //是否显示头部
  }
};
</script>

<style scoped>
@import "../../components/style.css";
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: 550px;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.cent {
  width: 100%;
  height: 200px;
}

.cent img {
  width: 100%;
  height: 200px;
}

.cent_1 {
  width: 1000px;
  height: 193px;
  background: #fff;
  position: absolute;
  left: 50%;
  margin-left: -500px;
  top: 167px;
}

.cent_nive {
  width: 700px;
  height: auto;
  margin: 30px 30px;
}

.cent_nive_1 {
  width: 100%;
  height: 48px;
  margin-bottom: 24px;
}

.cent_img {
  width: 48px;
  height: 48px;
  background: #000;
  float: left;
}

.cent_nive_1 p {
  font-size: 14px;
  font-weight: 600;
  line-height: 40px;
  padding: 0 10px;
  float: left;
}

.content_one2_right1 {
  width: 100%;
  height: 35px;
}

.content_one2_right1 p {
  float: left;
  font-size: 14px;
  margin-bottom: 10px;
}

.content_one2_right1 p:first-child {
  color: #999999;
}

.content_one2_right1 p:last-child {
  padding: 0 20px;
}

.content {
  width: 100%;
  height: auto;
  background: #f4f5f9;
  overflow: hidden;
}

.content_1 {
  width: 1000px;
  height: auto;
  margin: 0 auto;
  background: #fff;
  margin-top: 144px;
}

.content_top {
  width: 100%;
  height: 48px;
  background: #e9ebf3;
}

.content_top div {
  width: 500px;
  height: 48px;
  text-align: center;
  float: left;
}

.content_top div img {
  float: left;
  margin: 14px 0 0 201px;
}

.content_top div p a {
  float: left;
  line-height: 48px;
  font-size: 18px;
  padding: 0 10px;
  color: #222;
}

.content_top div.active {
  background: #fff;
  border-top: 2px solid #00c1de;
}

.content_top div.active p a {
  color: #00c1de;
}

.content_moban {
  width: 100%;
  height: auto;
  overflow: hidden;
  margin-bottom: 20px;
}

.content_moban_1 {
  width: 100%;
  height: 410px;
  margin-bottom: 40px;
}

.content_four_1_1 {
  font-size: 20px;
  font-weight: 600;
  padding: 0 30px;
  border-left: 5px solid #00c1de;
  margin: 30px 0;
}

.content_moban_bot {
  width: 900px;
  height: auto;
  margin: 0 auto;
  border-bottom: 2px solid #e4e4e4;
}

.shuom {
  width: 80px;
  font-size: 14px;
  color: #666666;
  float: left;
  text-align: right;
}

.content_moban_bot_1 {
  width: 900px;
  height: 58px;
}

.content_moban_bot_1 p:last-child {
  width: 690px;
  float: left;
  font-size: 14px;
  margin-bottom: 20px;
  padding: 0 20px;
}

.content_moban_bot_2 {
  width: 900px;
  height: 96px;
  margin-bottom: 20px;
}

.content_moban_bot_2 p {
  width: 80px;
  font-size: 14px;
  color: #666;
  text-align: right;
  float: left;
  line-height: 35px;
}

.content_moban_bot_3 {
  width: 900px;
  height: 58px;
  margin-bottom: 20px;
}

.content_moban_bot_3 p {
  width: 80px;
  font-size: 14px;
  color: #666;
  text-align: right;
  float: left;
  line-height: 35px;
}

.input {
  width: 699px;
  height: 96px;
  float: left;
  padding: 0 20px;
}

.zerren_input {
  width: 699px;
  height: 96px;
  float: left;
}

.riqi {
  width: 270px;
  margin: 0 20px;
  float: left;
}

.riqi2 {
  width: 270px;
  margin: 0 20px 0 0;
  float: left;
}

.riqi1 {
  width: 400px;
}

.input1 {
  width: 270px;
  height: 36px;
  float: left;
  margin: 0 20px;
}

.input2 {
  width: 270px;
  height: 36px;
  float: left;
}

.content_moban_2 {
  width: 100%;
  height: auto;
  margin-bottom: 24px;
}

.content_moban_top {
  width: 950px;
  height: 294px;
  background: #f8f8f8;
  margin: 0 auto;
  overflow: hidden;
  margin-bottom: 30px;
  position: relative;
}

.content_moban_p {
  font-size: 14px;
  float: left;
  line-height: 35px;
  padding: 0 20px;
  color: #666666;
}

.content_moban_top_1 {
  width: 100%;
  height: 36px;
  margin-top: 24px;
  margin-bottom: 24px;
}

.content_moban_top_2 {
  width: 100%;
  height: 50px;
  margin-top: 24px;
  margin-bottom: 24px;
}

.int {
  width: 699px;
  height: 36px;
  float: left;
}

.content_moban_bottom {
  width: 900px;
  height: 70px;
  border-bottom: 2px solid #e4e4e4;
  margin: 0 auto;
  text-align: center;
}

.content_moban_bottom img {
  width: 126px;
  height: 32px;
}

.zerren {
  width: 900px;
  height: 506px;
  margin: 0 auto;
}

.zerren1 {
  width: 100%;
  height: 96px;
  margin: 0 0 24px 0;
}

.zerren_1 {
  width: 90px;
  height: 31px;
  color: #666666;
  margin-right: 20px;
  float: left;
  margin-top: 10px;
  font-size: 14px;
}

.content_moban_3 {
  width: 1000px;
  height: auto;
  margin: 0 auto;
  background: #fff;
  margin-bottom: 40px;
}

.content_moban_thee {
  width: 100%;
  height: 60px;
  background: #e4e4e4;
}

.content_moban_thee p {
  text-align: center;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(34, 34, 34, 1);
  line-height: 60px;
}

.content_moban_three {
  width: 1000px;
  height: 300px;
  overflow-y: scroll;
  margin: 0 auto;
}

.content_moban_three_1 {
  width: 900px;
  height: auto;
  margin: 0 auto;
}

.content_moban_three_1 p {
  margin-bottom: 10px;
}

/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 5px;
  background-color: #fff;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 10px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #e4e4e4;
}
.bottom {
  width: 260px;
  height: 44px;
  background: rgba(0, 193, 222, 1);
  border-radius: 4px;
  margin: 0 auto;
  margin-bottom: 26px;
  text-align: center;
}

.bottom a {
  color: #fff;
  line-height: 44px;
}

.content_zdy {
  width: 100%;
  height: auto;
  overflow: hidden;
  margin-bottom: 20px;
}

.content_zdy_1 {
  width: 100%;
  height: 650px;
  background: #fff;
  margin-bottom: 24px;
  overflow: hidden;
}

.content_zdy_2 {
  width: 900px;
  height: 478px;
  margin: 0 auto;
}

.content_zdy_bottom {
  width: 700px;
  height: 304px;
  margin: 0 auto;
}

.content_moban_bottom_1 img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 10px;
  right: 20px;
}

.dialoa_top {
  width: 100%;
  height: 60px;
  background: #f4f5f9;
  border-radius: 5px;
}

.dialoa_top p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #222222;
  text-align: center;
  line-height: 60px;
}

.dialoa_left {
  width: 100%;
  height: 460px;
}

.dialoa_left_1 {
  width: 58%;
  height: auto;
  margin: 30px 45px;
}

.download {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666;
  float: right;
}

.dialoa_left_one {
  width: 226px;
  height: 337px;
  margin: 50px auto;
}

.dialoa_left_one p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}

.dialoa_left_one_img {
  width: 172px;
  height: 172px;
  margin-top: 20px;
  margin-left: 25px;
}

.dialoa_left_two {
  width: 85%;
  height: auto;
  margin: 0 auto;
}

.dialoa_left_two p {
  margin-bottom: 20px;
}
.dialoa_left_two p a {
  color: #4e8dee;
  margin-bottom: 20px;
}

.dialoa_left_two_1 {
  width: 100%;
  height: 283px;
  overflow-y: scroll;
  margin-bottom: 20px;
}

.submission {
  width: 180px;
  height: 44px;
  background: #00c1de;
  margin-left: 280px;
}

.dialog1_cont {
  width: 82px;
  height: 152px;
  margin: 0 auto;
}

.dialog1_cont img {
  margin-top: 36px;
}

.dialog1_cont_p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #222;
  text-align: center;
  margin-bottom: 20px;
}

.dialog1_cont_p1 {
  width: 432px;
  height: 55px;
  text-align: center;
  margin: 0 auto;
  color: #666666;
  margin-bottom: 20px;
}

.dialog1_bootm {
  width: 380px;
  height: auto;
  margin: 0 auto;
}

.dialog1_bootm1 {
  width: 180px;
  height: auto;
  margin: 0 auto;
}

.botton_botm {
  width: 180px;
  height: 44px;
  margin-bottom: 20px;
}

.button_fan {
  width: 180px;
  height: 44px;
  margin-bottom: 20px;
  background: #00c1de;
  border: 0;
}
</style>
<style>
.el-radio__label {
  font-size: 18px;
}
.el-radio__input.is-checked + .el-radio__label {
  color: #00c1de;
}

.el-radio__input.is-checked .el-radio__inner {
  background-color: #00c1de;
  border-color: #00c1de;
}

.el-checkbox__inner:hover {
  border-color: #00c1de;
}

.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #00c1de;
}

.el-button--primary.is-plain {
  color: #00c1de;
  border-color: #00c1de;
  background: #fff;
}

.is-plain {
  background: #00c1de;
}

.el-button--primary.is-plain:focus,
.el-button--primary.is-plain:hover {
  background: #00c1de;
}
</style>



// WEBPACK FOOTER //
// src/view/Dingdan/Faqihetong.vue